import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Popover } from "antd";
import React from "react";
import { NotfEnums } from "../types/enumerations";

type ICreateOptionsProps = {
    onCreateNotification: (notfType: NotfEnums.NOTIFICATION_TYPE) => void
}

const CreateOptions: React.FC<ICreateOptionsProps> = ({ onCreateNotification }) => {
    return <Popover
        overlayClassName="alert-control-overlay"
        content={
            <>
                <div className="padding-bottom-sm cursor-pointer" onClick={() => onCreateNotification(NotfEnums.NOTIFICATION_TYPE.SITE_ALERTS)}>
                    Site alert
                </div>
                <div className="padding-bottom-sm cursor-pointer" onClick={() => onCreateNotification(NotfEnums.NOTIFICATION_TYPE.MAINTENANCE)}>
                    Maintenance
                </div>
                <div className="padding-bottom-sm cursor-pointer" onClick={() => onCreateNotification(NotfEnums.NOTIFICATION_TYPE.INCIDENTS)}>
                    Incident
                </div>
                <div className="cursor-pointer" onClick={() => onCreateNotification(NotfEnums.NOTIFICATION_TYPE.GLOBAL_NOTIFICATIONS)}>
                    Global
                </div>
            </>
        }
    >
        <Button type="primary" >
            <FontAwesomeIcon className="margin-right-xs" icon={faPlus} />
            Create
        </Button>
    </Popover>
}

export default CreateOptions;
